// show all button script code for collection

 $(document).ready(function() {

   setTimeout(function () {
     
   var total_products= $(".product-count__text.boost-pfs-filter-total-product").text();
   var  total_productss= total_products.replace('products', '');      
   var total_p_n = Number(total_productss.trim());
     
     
    var last_pagination= parseFloat(total_p_n / 16);     
    var last_paginationn = (Math.round(last_pagination));    
     //alert(last_pagination);
     var show_all_btn=`<button class="boost-pfs-filter-show-all-button" id="show_all_btn">Show All</button>`;
      $(show_all_btn).insertAfter(".boost-pfs-filter-load-more-button");
     
      //show all btn click
        $("#show_all_btn").click(function() {
         var currenct_full_url = window.location.href;          
          if (window.location.href.indexOf("page") > -1) {
          var url = currenct_full_url.split('=');           
          var redirect_show_all_url = url[0]+"="+last_paginationn; 
             //console.log(redirect_show_all_url);
          window.location.replace(redirect_show_all_url);
          }
          else{
          var url = currenct_full_url;
          var redirect_show_all_url = url+"?page="+last_paginationn;
            
          var collection_id= $("#collection_id").val();
            var url ="https://great-british-interiors.myshopify.com/admin/api/2022-01/collections/"+collection_id+"/products.json";
            $.ajax({
                  url: url,
                  type: 'GET',
                  dataType: 'json', 
                  success: function(res) {
                
                    var collection_name= $('#collection_id').attr('collection_name');
                    $("#main-collection-product-grid").empty();
                    for (const element of res.products) {  
                  var pr_url = `https://great-british-interiors.myshopify.com/admin/api/2022-01/products/${element.id}.json`;    
                      
                  $.ajax({
                  url: pr_url,
                  type: 'GET',
                  dataType: 'json', 
                  success: function(ress) {
                    
                      var tags_array = ress.product.tags.split(",");
   
                   var items = `<div class="grid__item boost-pfs-action-list-enabled" data-id="${element.id}" data-page="1">
                    <div class="card-wrapper">
                      <div class="card-information">
                        <div class="card-information__wrapper">

                          <h3 class="card-information__text h5">
                              <a href="/collections/${ collection_name }/products/${element.handle}" class="full-unstyled-link">
                               ${element.title}
                            </a>
                          </h3>

                         <div class="price  ">
                                      <div>
                                          <div class="price__regular">
                                              <span id="from_text">From</span> 
                                              <span class="visually-hidden visually-hidden--inline">
                                                  Regular price
                                              </span>
                                              <span class="price-item price-item--regular">
                                                  £${ress.product.variants[0].price}
                                              </span>
                                          </div>
                                          <div class="price__sale">
                                              <span class="visually-hidden visually-hidden--inline">
                                                  Regular price
                                              </span>
                                              <span>
                                                  <s class="price-item price-item--regular">
                                                      £${ress.product.variants[0].price}
                                                  </s>
                                              </span>
                                              <span class="visually-hidden visually-hidden--inline">translation missing: en.products.product.sale_price</span>
                                              <span class="price-item price-item--sale price-item--last">
                                                  £${ress.product.variants[0].price}
                                              </span>
                                          </div>
                                          <small class="unit-price caption hidden">
                                              <span class="visually-hidden">Unit price</span>
                                              <span class="price-item price-item--last">
                                                  <span>£0</span>
                                                  <span aria-hidden="true">/</span>
                                                  <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                              </span>
                                        </small>
                                      </div>
                                  </div>

                                 <!--<div class="card__badge">

                            <span class="badge badge--bottom-left color-accent-2" aria-hidden="true">
                               Sale
                             </span>
                          </div>-->

                        </div>
                      </div>
                      <div class="card card--product card--outline" tabindex="-1">
                        <div class="card__inner">
                          <div class="product_image"><div class="media media--transparent media--adapt media--hover-effect boost-pfs-action-overlay" style="padding-bottom: 137.4581939799331%"><img class="motion-reduce" loading="lazy" srcset="${element.image.src}" alt="${element.title}"></div></div>
                           <!--<div class="products_tags"><p>Best_Seller</p></div>-->

                        </div>
                      </div>
                    </div>
                  <div class="boost-pfs-action-list-wrapper boost-pfs-action-extend" style="top: 320px; width: 198px; visibility: visible;"><form method="post" action="/cart/add" accept-charset="UTF-8" class="boost-pfs-addtocart-product-form" enctype="multipart/form-data" data-href="/collections/${ collection_name }/products/${element.handle}">
                                  <input type="hidden" name="form_type" value="product">
                                  <input type="hidden" name="quantity" value="1" min="1">
                                  <input type="hidden" name="id" value="42178038333694">
                                  <div class="boost-pfs-addtocart-wrapper">
                                      <button aria-label="Add To Cart" name="add" class="boost-pfs-addtocart-btn boost-pfs-addtocart-select-options" type="submit">
                                          <span> <svg width="40" height="40" viewBox="0 0 40 40"><g id="boost-pfs-icon-cart" transform="scale(0.03125 0.03125)"><path d="M448.217 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256s102.256-45.879 102.256-102.256c0-56.379-45.857-102.256-102.256-102.256zM448.217 977.908c-31.312 0-56.807-25.472-56.807-56.807 0-31.312 25.495-56.807 56.807-56.807s56.807 25.495 56.807 56.807c0.003 31.335-25.472 56.807-56.807 56.807z"></path><path d="M768.66 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256 56.354 0 102.256-45.879 102.256-102.256 0-56.379-45.902-102.256-102.256-102.256zM768.66 977.908c-31.335 0-56.807-25.472-56.807-56.807 0-31.312 25.472-56.807 56.807-56.807 31.29 0 56.807 25.495 56.807 56.807 0.003 31.335-25.517 56.807-56.807 56.807z"></path><path d="M1019.164 259.373c-4.294-5.499-10.886-8.702-17.883-8.702h-768.3l-63.329-233.255c-0.137-0.5-0.5-0.886-0.682-1.364-0.5-1.476-1.25-2.773-2.046-4.090-0.749-1.25-1.431-2.477-2.385-3.545-0.931-1.068-2.021-1.865-3.159-2.726-1.182-0.909-2.317-1.795-3.659-2.454-1.25-0.637-2.591-0.953-3.975-1.364-1.476-0.431-2.907-0.794-4.476-0.909-0.545-0.022-1.001-0.319-1.568-0.319h-124.978c-12.543 0-22.724 10.181-22.724 22.724s10.181 22.724 22.724 22.724h107.595l63.239 232.959 113.572 460.078c2.499 10.156 11.612 17.293 22.065 17.293h558.448c10.452 0 19.543-7.112 22.065-17.293l113.617-460.282c1.7-6.796 0.154-13.955-4.162-19.476zM869.871 710.976h-522.865l-102.39-414.858h727.667l-102.413 414.858z"></path></g></svg><span class="boost-pfs-addtocart-btn-text">Add To Cart</span></span>
                                      </button>
                                  </div>
                              </form><button class="boost-pfs-quickview-btn boost-pfs-filter-button" data-href="/collections/${ collection_name }/products/${element.handle}?view=boost-pfs-quickview" aria-label="Quick View">
                                  <span>
                                      <svg width="40" height="40" viewBox="0 0 40 40"><g id="boost-pfs-icon-quick-view" transform="scale(0.03125 0.03125)"><path d="M1009.004 493.256c-2.256-2.82-56.254-69.828-143.786-137.492-51.696-39.962-104.462-71.87-156.832-94.834-66.48-29.152-132.556-43.932-196.386-43.932-63.832 0-129.904 14.782-196.386 43.932-52.37 22.962-105.136 54.87-156.834 94.834-87.53 67.666-141.528 134.674-143.784 137.494l-14.996 18.742 14.998 18.744c2.256 2.82 56.252 69.828 143.784 137.492 51.696 39.962 104.462 71.87 156.834 94.834 66.48 29.152 132.554 43.932 196.386 43.932 63.83 0 129.904-14.782 196.386-43.932 52.37-22.962 105.136-54.87 156.832-94.834 87.53-67.666 141.53-134.674 143.786-137.492l14.994-18.744-14.996-18.744zM827.402 621.624c-74.24 57.196-189.226 125.374-315.402 125.374-126.18 0-241.162-68.178-315.402-125.374-55.36-42.65-97.042-85.794-118.512-109.612 52.994-58.698 229.246-235.006 433.916-235.006 126.178 0 241.162 68.178 315.402 125.374 55.366 42.654 97.050 85.8 118.522 109.622-21.474 23.82-63.158 66.968-118.524 109.622z"></path><path d="M512 309.976c-111.396 0-202.024 90.63-202.024 202.024s90.63 202.024 202.024 202.024 202.026-90.628 202.026-202.024-90.63-202.024-202.026-202.024zM512 654.018c-78.308 0-142.018-63.71-142.018-142.018s63.71-142.018 142.018-142.018 142.018 63.71 142.018 142.018c0 78.308-63.71 142.018-142.018 142.018z"></path><path d="M512 419.322c-51.102 0-92.678 41.576-92.678 92.678s41.576 92.68 92.678 92.68 92.678-41.576 92.678-92.68c0-51.104-41.574-92.678-92.678-92.678zM512 544.672c-18.014 0-32.67-14.656-32.67-32.672s14.656-32.67 32.67-32.67 32.67 14.656 32.67 32.67c0.002 18.014-14.654 32.672-32.67 32.672z"></path></g></svg>
                                  </span>
                              </button></div></div>`
          
                      
                      $("#main-collection-product-grid").append(items);
                      $(".boost-pfs-filter-load-more").css("display","none");
                    
                    $(".boost-pfs-filter-load-more-total").text(`Viewing all of ${total_p_n} products`);
                    
                      
                    }
                  });
                            
                      
                  }
                      
                  }
              });

            
          }
           $("html, body").animate({ scrollTop: 0 }, "slow");
                      return false;
          
        });
     
   }, 3000);
   
    setInterval(function () {
      var product_text_lower = $(".boost-pfs-filter-load-more-total").text();      

      
     $(".boost-pfs-filter-load-more-totall").text(product_text_lower);
      
      
      if ($(".boost-pfs-filter-load-more").css('display') == 'none'){
        $(".boost-pfs-filter-load-more-total").addClass("margin_cls");
        
      }
      else{
        $(".boost-pfs-filter-load-more-total").addClass("margin_clss");
      }
     }, 1000);   
   
   
 //loadmore worked on clcik event
    // $(".boost-pfs-filter-load-more").click(function() {
    //    setInterval(function () {
    //   var numItems = $(' .grid__item.boost-pfs-action-list-enabled').length         
    //      $(".boost-pfs-filter-load-more-total").text(`Viewing 1 - ${numItems} of ${my_variable} products`);
    //      }, 2000);
    //   }); 
   
// worked on page load
//     setInterval(function () {
// var numItems = $(' .grid__item.boost-pfs-action-list-enabled').length       
//    $(".boost-pfs-filter-load-more-total").text(`Viewing 1 - ${numItems} of ${my_variable} products`);   
//      }, 2000);  
});

 
 

//header code 
$(document).ready(function(){ 
	$(".megamenu").on("click", function(e) {
		e.stopPropagation(); 
	});

$("#shopify-section-announcement-bar").css("display", "none");  

$(".closed_ann_bar").click(function(){
  $("#shopify-section-announcement-bar").slideToggle("slow");
  localStorage.setItem("announce_closed", "1");
});
if(localStorage.getItem("announce_closed") == "1" ){
    $("#shopify-section-announcement-bar").css("display", "none");
    
}else{
   $("#shopify-section-announcement-bar").css("display", "block");
}
}); 


// form validations rules

$(document).ready (function () { 
  
 // logic  form validation
  
 $('#login_form_btn').on('click', function(e) {   
  $("#CustomerEmail").removeClass("error");
  $("#CustomerEmail-error").remove();
    var email = $('#CustomerEmail').val();  
    var password = $('#CustomerPassword').val();  
   
  $(".error").remove();  
 
    if (email.length < 1) {  
      $('#customer_email_error').append('<span class="error">This field is required</span>'); 
      e.preventDefault();
    } 
  if(email.length > 1) {  
      var regEx = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;   
    if(!regEx.test(email)) { 
        $('#customer_email_error').append('<span class="error">Email is invalid</span>'); 
        e.preventDefault();
      }  
    }  
    if (password.length < 1) {  
      $('#customer_password_error').append('<span class="error">This field is required</span>'); 
      e.preventDefault();
    }  
  });  
  

  
//forget password from  
  
  
 $('#recover_customer_password_btn').on('click', function(e) {  
      
  $("#RecoverEmail").removeClass("error");
  $("#RecoverEmail-error").remove();
    var email = $('#RecoverEmail').val();   
   
  $(".error").remove();  
 
    if (email.length < 1) {  
      $('#recover_email_error').append('<span class="error">This field is required</span>');
      e.preventDefault();
    } 
  if(email.length > 1) {  
      var regEx = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;    
    if(!regEx.test(email)) { 
        $('#recover_email_error').append('<span class="error">Email is invalid</span>');
        e.preventDefault();
      }  
    }  
  
  });  
  

  
  
  
// register  form validation
  
 $('#create_customer_btn').on('click', function(e) {  

          $("#RegisterForm-email").removeClass("error");
          $("#RegisterForm-email-error").remove();
          var email = $('#RegisterForm-email').val();  
          var password = $('#RegisterForm-password').val();
          var FirstName = $('#RegisterForm-FirstName').val();  
          var LastName = $('#RegisterForm-LastName').val(); 

        $(".error").remove();  
           if (FirstName.length < 1) {  
            $('#customer_first_error').append('<span class="error">This field is required</span>'); 
             e.preventDefault(); 
          } 
          if (LastName.length < 1) {  
            $('#customer_last_error').append('<span class="error">This field is required</span>'); 
            e.preventDefault(); 
          } 
          if (email.length < 1) {  
            $('#customer_email_error').append('<span class="error">This field is required</span>'); 
            e.preventDefault(); 
          } 
        if(email.length > 1) {  
            var regEx = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;    
          if(!regEx.test(email)) { 
              $('#customer_email_error').append('<span class="error">Email is invalid</span>'); 
            e.preventDefault(); 
            }  
          }  
          if (password.length < 1) {  
            $('#customer_password_error').append('<span class="error">This field is required</span>'); 
            e.preventDefault(); 
          }  
 });  




//product code start from here

//on load 


$(document).ready(function() {
  
  /*let radio_selected_val = $('input[name="lining"]:checked').val();
  
  $(".lining_show select option").each(function(i) {
    $(this).removeAttr('selected'); 
    
    if(radio_selected_val == $(this).val()){
    
      $(this).attr("selected","selected");
    }
    
});*/
  
//option line
/*$('.lining_show .select__select').on('change', function() {
var selected_value = this.value.trim();
 $('[name="lining"]').removeAttr('checked');
 
           var main_select = document.querySelector('#lining');
          var options = main_select.querySelectorAll("input");
          options.forEach(function(option, index){
              var opt_text = option.value;
              var size = opt_text.trim();
              if(size ==selected_value){
                 var main_selectt = option.value;                
                const radioToUpdate = options[index];
                      radioToUpdate.checked = true;
              }
          }); 
    
});*/  

 
//option style code start here//
  
/*let radio_selected_val_style = $('input:radio[name="Style"]:checked').val();

  
  $(".Style option").each(function(i) {
    $(this).removeAttr('selected'); 
    
    if(radio_selected_val_style == $(this).val()){
    
      $(this).attr("selected","selected");
    }
    
}); */ 
  
  
/*$("input:radio[name='Style']").on('change', function() {
  
var selected_value = this.value.trim();
  
          var main_select = document.querySelector('.Style');
          var options = main_select.querySelectorAll('option');
          options.forEach(function(option, index){
              var opt_text = option.textContent;
              var size = opt_text.trim();
              if(size == selected_value){
                  main_select.value = option.value;
                  main_select.dispatchEvent(new Event('change'))
              }
          }); 
  
// price changed
  /*setInterval(function () {
 var one_price_v = $('#app_price_add .price__regular .price-item--regular').text(); 
   var two_price_v = $('#app_price_add #price-item--regular-id').val(); 
  
  var two_price_v_remove_$ = two_price_v.substring(1);
  if(!isNaN(parseInt(two_price_v_remove_$))){
    
  if(parseInt( two_price_v_remove_$) >= 0 ){

    var current_product__title= $("#template_name_p").val();

    if(current_product__title == "curtain"){ 
      
    var id_mw_option = $(".mw-option__control--type-select").attr('id');
    var iddd ="#"+id_mw_option+" :selected"; 
    var app_slected_option =$(iddd).text();

    }
    if(current_product__title == "blind"){
      var id_mw_option = $(".mw-option__control--type-select").attr('id');
      var iddd ="#"+id_mw_option+" :selected"; 
      var app_slected_option =$(iddd).text();
     
    }
    
    if( !app_slected_option.includes("Please Select") && !app_slected_option.includes("--Please Select--") ){
    var app_slected_optionn = app_slected_option.split('£')[1];

    var app_slected_optionnn = app_slected_optionn.split(")")[0];
     var app_slected_optionnnn = parseFloat(app_slected_optionnn);
      
      var app_pri_reg=(parseFloat( two_price_v_remove_$) + parseFloat(app_slected_optionnnn)).toFixed(2);
      var final_pri_after_add= "£"+app_pri_reg;
      $('#app_price_add .price-item--regular').text(final_pri_after_add); 
    }

    
  }  
  }  
    },10----/
  // price changed 
  
  
  
});   */
  
//option style code start here//
  
  $(".size_select_option .select__select option").each(function(i, e) { 
    var checked_radio_value_index =0;
    $("input:radio[name='Size']").each(function(i) {
       if (this.checked) {
         
         checked_radio_value_index=i;
       }
    });
 
    // get the options
    var input_t=`<input type="radio" id="Size-${i}" name="size_radio" value="${$(this).val()}">
     <span id="Size-0_text_radio">${$(this).val()}</span>`;
    $(input_t) // create a radio element
        .attr("value", $(this).val()) // set the value
        .attr("checked", i == checked_radio_value_index) // check the first by default
        .click(function () { // add event click which updates the dropdown
            $('#radio_div_second [name="size_radio"]').removeAttr('checked');
            $(".size_select_option .select__select").val($(this).val()); // update the dropdown if clicked
            $(this).attr('checked',true);
        })
        .appendTo("#radio_div_second"); // append to some visible place
});  
  
  
$('input:radio[name="size_radio"]').on('change', function() {
var selected_value = this.value;
 $('[name="Size"]').removeAttr('checked');
  
  $("input:radio[name='Size']").each(function(i) {
    
   
    if(selected_value == $(this).val()){
      $(this).attr('checked',true);
    }
    
});  

// price changed
  /*setInterval(function () {
 var one_price_v = $('#app_price_add .price__regular .price-item--regular').text(); 
   var two_price_v = $('#app_price_add #price-item--regular-id').val(); 
  
  var two_price_v_remove_$ = two_price_v.substring(1);
  if(!isNaN(parseInt(two_price_v_remove_$))){
    
  if(parseInt( two_price_v_remove_$) >= 0 ){

    var current_product__title= $("#template_name_p").val();

    if(current_product__title == "curtain"){ 
    var id_mw_option = $(".mw-option__control--type-select").attr('id');
    var iddd ="#"+id_mw_option+" :selected";
    var app_slected_option =$(iddd).text();
  
    }
    if(current_product__title == "blind"){
     var id_mw_option = $(".mw-option__control--type-select").attr('id');
     var iddd ="#"+id_mw_option+" :selected";
     var app_slected_option =$(iddd).text();

    }
    
    if( !app_slected_option.includes("Please Select") && !app_slected_option.includes("--Please Select--") ){
    var app_slected_optionn = app_slected_option.split('£')[1];

    var app_slected_optionnn = app_slected_optionn.split(")")[0];
     var app_slected_optionnnn = parseFloat(app_slected_optionnn);
      
      var app_pri_reg=(parseFloat( two_price_v_remove_$) + parseFloat(app_slected_optionnnn)).toFixed(2);
      var final_pri_after_add= "£"+app_pri_reg;
      $('#app_price_add .price-item--regular').text(final_pri_after_add); 
    }

    
  }  
  }  
    },10);*/
  // price changed 
  
  
  
});   
  
//option single and pair code start here//
 /*var current_product__titleee= $("#template_name_p").val();
  if((current_product__titleee == "curtain")){
    
  var size_radio_value= $('input[name="size_radio"]:checked').val();
 var selected_valuen = size_radio_value.trim();


  var main_selectn = document.querySelector('#size_select_option_size .select__select ');
  var optionsn = main_selectn.querySelectorAll('option');
  optionsn.forEach(function(optionn, indexn){
      var opt_textn = optionn.textContent;
      var sizen = opt_textn.trim();
      if(sizen == selected_valuen){
      
          main_selectn.value = optionn.value;
          main_selectn.dispatchEvent(new Event('change'))
      }
  }); 
  }*/
  
//option single and pair code start here//   
  
});



  

 

//curtain product option code

 /*$( ".curtain_product_wd,.curtain_product_dp" ).on('input', function(event) {

         $('.wd_cl select option').removeAttr('selected');
        var curtain_product_wd = $('.curtain_product_wd').val(); 
        var curtain_product_dp = $('.curtain_product_dp').val(); 
        var curtain_product_wdd=0;
        var curtain_product_dpp=0;
        var curtain_product_wd_last_number = curtain_product_wd[curtain_product_wd.length -1];
        var curtain_product_dp_last_number = curtain_product_dp[curtain_product_dp.length -1]; 
   
        var curtain_product_wd_last_number = parseInt(curtain_product_wd_last_number);
        var curtain_product_dp_last_number = parseInt(curtain_product_dp_last_number);
   
           //curtain_product_wd
   
           if(parseInt(curtain_product_wd_last_number) == 1) {
               curtain_product_wdd =parseInt(curtain_product_wd) + 4;
            }
            else if(parseInt(curtain_product_wd_last_number) == 2) {
               curtain_product_wdd =parseInt(curtain_product_wd) + 3;
            }
            else if(parseInt(curtain_product_wd_last_number) == 3) {
               curtain_product_wdd =parseInt(curtain_product_wd) + 2;
            }
            else if(parseInt(curtain_product_wd_last_number) == 4) {
               curtain_product_wdd =parseInt(curtain_product_wd) + 1;
            }
            else if(parseInt(curtain_product_wd_last_number) == 5) {
               curtain_product_wdd =parseInt(curtain_product_wd);
            }
            else if(parseInt(curtain_product_wd_last_number) == 6) {
               curtain_product_wdd =parseInt(curtain_product_wd) + 4;
            }
            else if(parseInt(curtain_product_wd_last_number) == 7) {
               curtain_product_wdd =parseInt(curtain_product_wd) + 3;
            }
            else if(parseInt(curtain_product_wd_last_number) == 8) {
               curtain_product_wdd =parseInt(curtain_product_wd) + 2;
            }
            else if(parseInt(curtain_product_wd_last_number) == 9) {
               curtain_product_wdd =parseInt(curtain_product_wd) + 1;
            }
            else if(parseInt(curtain_product_wd_last_number) == 10) {
               curtain_product_wdd =parseInt(curtain_product_wd);
            }else{
              curtain_product_wdd =parseInt(curtain_product_wd);
            }
   
            //curtain_product_dp

            if(parseInt(curtain_product_dp_last_number) == 1) {
               curtain_product_dpp =parseInt(curtain_product_dp) + 4;
            }
            else if(parseInt(curtain_product_dp_last_number) == 2) {
               curtain_product_dpp =parseInt(curtain_product_dp) + 3;
            }
            else if(parseInt(curtain_product_dp_last_number) == 3) {
               curtain_product_dpp =parseInt(curtain_product_dp) + 2;
            }
            else if(parseInt(curtain_product_dp_last_number) == 4) {
               curtain_product_dpp =parseInt(curtain_product_dp) + 1;
            }
            else if(parseInt(curtain_product_dp_last_number) == 5) {
               curtain_product_dpp =parseInt(curtain_product_dp);
            }
            else if(parseInt(curtain_product_dp_last_number) == 6) {
               curtain_product_dpp =parseInt(curtain_product_dp) + 4;
            }
            else if(parseInt(curtain_product_dp_last_number) == 7) {
               curtain_product_dpp =parseInt(curtain_product_dp) + 3;
            }
            else if(parseInt(curtain_product_dp_last_number) == 8) {
               curtain_product_dpp =parseInt(curtain_product_dp) + 2;
            }
            else if(parseInt(curtain_product_dp_last_number) == 9) {
               curtain_product_dpp =parseInt(curtain_product_dp) + 1;
            }
            else if(parseInt(curtain_product_dp_last_number) == 10) {
               curtain_product_dpp =parseInt(curtain_product_dp);
            }else{
              curtain_product_dpp =parseInt(curtain_product_dp);
            }
   
   
         var fi_wd=curtain_product_wdd+'x'+curtain_product_dpp; 
         
         if(curtain_product_wd =="" && curtain_product_dp==""){
          var template_name_p = $("#template_name_p").val();
           
          if(template_name_p =="curtain"){
            
           $("#wdr #ws").text("Please enter your required length");
            
           }
           else{
             
             $("#wdr #ws").text("Please enter your required width");
           }
           
          $("#wdr #ds").text("Please enter your required drop");
            event.preventDefault(); 
        }
        
       if(curtain_product_wd =="" && curtain_product_dp!=""){
          var template_name_p = $("#template_name_p").val();
           
          if(template_name_p =="curtain"){
            
           $("#wdr #ws").text("Please enter your required length");
            
           }
           else{
             
             $("#wdr #ws").text("Please enter your required width");
           }
           
            event.preventDefault(); 
        }
        if(curtain_product_wd !="" && curtain_product_dp==""){
          var template_name_p = $("#template_name_p").val();
           
          $("#wdr #ds").text("Please enter your required drop");
            event.preventDefault(); 
        }
   
        if(curtain_product_wd < 10 && curtain_product_wd !=""){
          
         var template_name_p = $("#template_name_p").val();
           
          if(template_name_p =="curtain"){
            
            $("#wdr #ws").text("Minimum length 10 cm");
            
           }
           else{
             
              $("#wdr #ws").text("Minimum width 10 cm");
           }
          
           event.preventDefault(); 
        }
        if(curtain_product_wd >= 10 && curtain_product_wd !=""){
         $("#wdr #ws").text('');
           event.preventDefault(); 
        }
        if(curtain_product_dp < 10 && curtain_product_dp !=""){
          $("#wdr #ds").text("Minimum drop 10 cm");
           event.preventDefault(); 
        }
        if(curtain_product_dp >= 10 && curtain_product_dp !=""){
          $("#wdr #ds").text('');
        }


      //option 

      if(curtain_product_wd >= 10 && curtain_product_dp >= 10){
         var current_product__title= $("#template_name_p").val();
        
        if(current_product__title == "curtain"){ 
         var id_mw_option = $(".mw-option__control--type-select").attr('id');
          var iddd ="#"+id_mw_option;
          var main_select = document.querySelector(iddd);
          var options = main_select.querySelectorAll('option');
          options.forEach(function(option, index){
              var opt_text = option.textContent;
              var size = opt_text.split('(')[0].trim();
              if(size.indexOf(fi_wd) > -1){
                  main_select.value = option.value;
                  main_select.dispatchEvent(new Event('change'))
              }
          }); 
         }
        if(current_product__title == "blind"){
         var id_mw_option = $(".mw-option__control--type-select").attr('id');
          var iddd ="#"+id_mw_option;
          var main_select = document.querySelector(iddd);
          var options = main_select.querySelectorAll('option');
          options.forEach(function(option, index){
              var opt_text = option.textContent;
              var size = opt_text.split('(')[0].trim();
              if(size.indexOf(fi_wd) > -1){
                console.log(option.value);
                  main_select.value = option.value;
                  main_select.dispatchEvent(new Event('change'))
              }
          }); 
        
        }

        } 
     
});*/
 
  

//on load get value of width and drop
  /*var curtain_product_wdd = $('.curtain_product_wd').val(); 
   var curtain_product_dpp = $('.curtain_product_dp').val(); 
  if(curtain_product_wdd == "" && curtain_product_dpp==""){
    $(".curtain_form_btn,.product-form__quantity,.second_option_section div").addClass("btn_hide_forwd");
  }
  setInterval(function () {
   var curtain_product_wdd = $('.curtain_product_wd').val(); 
   var curtain_product_dpp = $('.curtain_product_dp').val(); 
  if(curtain_product_wdd == "" && curtain_product_dpp==""){
    $(".curtain_form_btn,.product-form__quantity,.second_option_section div").addClass("btn_hide_forwd");
  }else{
   $(".curtain_form_btn,.product-form__quantity,.second_option_section div").removeClass("btn_hide_forwd");
  }
    
}, 100);*/

  
  // on click .first_option_section
 /*$('.first_option_section').on('click', function(e) {  
        
        $('html').animate({
        scrollTop: $(".breadcrumbs").offset().top
        }, 1000);
        
        var curtain_product_wddd = $('.curtain_product_wd').val(); 
        var curtain_product_dppp = $('.curtain_product_dp').val(); 

           
        if(curtain_product_wddd =="" && curtain_product_dppp==""){
                    
          var template_name_p = $("#template_name_p").val();
           
          if(template_name_p =="curtain"){
            
           $("#wdr #ws").text("Please enter your required length");
            
           }
           else{
             
              $("#wdr #ws").text("Please enter your required width");
           }
          
          
          $("#wdr #ds").text("Please enter your required drop");
            event.preventDefault(); 
        }
        if(curtain_product_wddd < 10 && curtain_product_wddd !=""){
          
         var template_name_p = $("#template_name_p").val();
           
          if(template_name_p =="curtain"){
            
           $("#wdr #ws").text("Minimum length 10 cm");
            
           }
           else{
             
             $("#wdr #ws").text("Minimum width 10 cm");
           }
          
           event.preventDefault(); 
        }
        if(curtain_product_wddd >= 10 && curtain_product_wddd !=""){
         $("#wdr #ws").text('');
           event.preventDefault(); 
        }
        if(curtain_product_dppp < 10 && curtain_product_dppp !=""){
          $("#wdr #ds").text("Minimum drop 10 cm");
           event.preventDefault(); 
        }
        if(curtain_product_dppp >= 10 && curtain_product_dppp !=""){
          $("#wdr #ds").text('');
        }
 }); */ 
  

  

//brand name setup 
 /*setInterval(function () {  
 var brands = $(".refine-by-option").text();
 var brand_name = $(".refine-by-value").text();
   if(brands.includes('Brands:')){ 
     $(".collection-hero__title span").remove();
     var collection_hero__title= $(".collection-hero__title").text().trim();
    var text_title_new =brand_name;
     $(".collection-hero__title").text(text_title_new);
   }else{
     $(".collection-hero__title").text(window.location.pathname.split("/").pop());
   }
 },1000);  
  
 });  */


//increase price
/*$(window).on('load', function() {
  
setInterval(function () {
   var one_price_v = $('#app_price_add .price__regular .price-item--regular').text(); 
   var two_price_v = $('#app_price_add #price-item--regular-id').val(); 
    var current_product__titlee= $("#template_name_p").val();
  if((current_product__titlee == "curtain") || (current_product__titlee == "blind")){ 
  var two_price_v_remove_$ = two_price_v.substring(1);
  if(!isNaN(parseInt(two_price_v_remove_$))){
    
  if(parseInt( two_price_v_remove_$) >= 0 ){

    var current_product__title= $("#template_name_p").val();

    if(current_product__title == "curtain"){ 
      
     var id_mw_option = $(".mw-option__control--type-select").attr('id');
      var iddd ="#"+id_mw_option+" :selected";
      var app_slected_option =$(iddd).text();
    }
    if(current_product__title == "blind"){

      var id_mw_option = $(".mw-option__control--type-select").attr('id');
      var iddd ="#"+id_mw_option+" :selected";
      var app_slected_option =$(iddd).text();
      console.log("app_slected_option"+app_slected_option)
     
    }
    
    if( !app_slected_option.includes("Please Select") && !app_slected_option.includes("--Please Select--") ){
    var app_slected_optionn = app_slected_option.split('£')[1];
    var app_slected_optionnn = app_slected_optionn.split(")")[0];
     var app_slected_optionnnn = parseFloat(app_slected_optionnn); 
      var app_pri_reg=(parseFloat( two_price_v_remove_$) + parseFloat(app_slected_optionnnn)).toFixed(2);
      var final_pri_after_add= "£"+app_pri_reg;
      $('#app_price_add .price-item--regular').text(final_pri_after_add); 
    }

    
  }  
  }
  }    
},50);
  
});*/

  // on click Style images roundup price of product with app price
 /*$('#Style .custom-radio-check').on('click', function(e) { 
   setInterval(function () {
      var one_price_v = $('#app_price_add .price__regular .price-item--regular').text(); 
   var two_price_v = $('#app_price_add #price-item--regular-id').val(); 
  
  var two_price_v_remove_$ = two_price_v.substring(1);
  if(!isNaN(parseInt(two_price_v_remove_$))){
    
  if(parseInt( two_price_v_remove_$) >= 0 ){

    var current_product__title= $("#template_name_p").val();

    if(current_product__title == "curtain"){ 
      
     var id_mw_option = $(".mw-option__control--type-select").attr('id');
      var iddd ="#"+id_mw_option+" :selected";
      var app_slected_option =$(iddd).text();
    }
    if(current_product__title == "blind"){
      var id_mw_option = $(".mw-option__control--type-select").attr('id');
      var iddd ="#"+id_mw_option+" :selected";
      var app_slected_option =$(iddd).text();
    }
    
    if( !app_slected_option.includes("Please Select") && !app_slected_option.includes("--Please Select--") ){
    var app_slected_optionn = app_slected_option.split('£')[1];
     var app_slected_optionnn = app_slected_optionn.split(")")[0];
     var app_slected_optionnnn = parseFloat(app_slected_optionnn);
      var app_pri_reg=(parseFloat( two_price_v_remove_$) + parseFloat(app_slected_optionnnn)).toFixed(2);
      var final_pri_after_add= "£"+app_pri_reg;
      $('#app_price_add .price-item--regular').text(final_pri_after_add); 
    }

    
  }  
  }  
     },10);
   
 }); */ 

//on changed lining select option//
$(".measuring_guide_option").click(function() {
    $('html,body').animate({
        scrollTop: $(".product__description").offset().top},
        'slow');
});
});